class LanguageTracking {
    constructor() {
        this.currentLanguage = window.Shopify.locale || '';
        this.currentCountry = window.Shopify.country || '';
        this.cookieKey = '_tracking_current_language';
    }

    setCookie(name, value, days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + date.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    trackLang() {
        const localizationData = { country: this.currentCountry, language: this.currentLanguage }
        this.setCookie(this.cookieKey, JSON.stringify(localizationData), 10);
    }
}

new LanguageTracking().trackLang();